
<template>
    <div class="c-baseImage" :class="modifiers" itemscope itemtype="https://schema.org/ImageObject">
        <picture v-if="img" :class="modifiers">
            <template v-if="sourceData && sourceData.length !== 0">
                <template v-for="(source, index) in sourceData">
                    <!-- Webp source -->
                    <source 
                        v-if="source.handleWebp"
                        :key="index"
                        :srcset="`${source.url}.webp`"
                        :width="source.width" 
                        :height="source.height"
                        :media="`(max-width: ${source.mediaMax})`"
                        type="image/webp"
                        itemprop="contentUrl"
                    >
                    <!-- Jpeg source -->
                    <source
                        v-if="source"
                        :key="index"
                        :srcset="source.url"
                        :width="source.width" 
                        :height="source.height"
                        :media="`(max-width: ${source.mediaMax})`"
                        type="image/jpeg"
                        itemprop="contentUrl"
                    >
                </template>
            </template>
            <source v-if="imgHandleWebp"
                :srcset="`${imgUrl}.webp`"
                :width="imgWidth" 
                :height="imgHeight"
                type="image/webp"
                itemprop="contentUrl"
            >
            <img 
                :ref="'img'"
                :loading="lazyload ? 'lazy' : null"
                :src="imgUrl"
                :alt="alt"
                :width="imgWidth" 
                :height="imgHeight"
                :class="imgClasses"
                :role="role"
                itemprop="contentUrl"
                @load="imageLoaded"
            >
        </picture>
        <template v-if="imgCredit">
            <small class="c-baseImage__credit"><span>©</span> <span class="c-baseImage__copyright__name" itemprop="creditText">{{ imgCredit }}</span></small>
        </template>
    </div>
</template>

<script>
    export default {
        name: 'BaseImage',
        components: {},
        props: {
            img: {
                type: Object,
                default: null
            },
            crop: {
                type: String,
                default: ''
            },
            sources: {
                type: Array,
                default: []
            },
            alt: {
                type: String,
                default: ''
            },
            lazyload: {
                type: Boolean,
                default: false
            },
            modifiers: {
                type: String,
                default: ''
            },
            imgClass: {
                type: String,
                default: ''
            },
            role: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                sourceData: []
            }
        },
        mounted() {
            // window.Store.lazyload.update();

            const webPCompatibleImageFormats = new RegExp(/[^\s]+(.*?).(jpe?g|png)$/, "i");

            this.sources.forEach((source)=>{
                const url = this.img.sizes[source.crop];
                const width = this.img.sizes[`${source.crop}-width`];
                const height = this.img.sizes[`${source.crop}-height`];
                const data = {
                    'url' : url,
                    'width' : width,
                    'height' : height,
                    'mediaMax' : source.mediaMax,
                    'placeholder' : `data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20${width}%20${height}%3E%3C/svg%3E`,
                    'handleWebp' : webPCompatibleImageFormats.test(url),
                }

                this.sourceData.push(data);
            });
        },
        updated(){
            if(this.lazyload || this.$refs.img.complete){
                return false;
            }

            this.$el.classList.add('is-loading');
        },
        computed: {
            imgUrl() {
                return this.img.sizes[this.crop];
            },
            imgWidth() {
                return this.img.sizes[`${this.crop}-width`];
            },
            imgHeight() {
                return this.img.sizes[`${this.crop}-height`];
            },
            imgPlaceholder() {
                return `data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20${this.imgWidth}%20${this.imgHeight}%3E%3C/svg%3E`;
            },
            imgHandleWebp() {
                return new RegExp(/[^\s]+(.*?).(jpe?g|png)$/, "i").test(this.imgUrl);
            },
            imgClasses() {
                let classes = '';
                
                if(this.imgClass){
                    classes += this.imgClass;
                }

                return classes;
            },
            imgCredit() {
                return this.img.description;
            }
        },
        methods: {
            imageLoaded(){
                if(this.lazyload){
                    return false;
                }

                this.$el.classList.remove('is-loading');
            }
        }
    }
</script>